<template>
  <div
    class="sn-bs-wrapper"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <main class="sn-bs-wrapper__main" v-show="!loading && categoryList.length">
      <div
        class="sn-bs-content-item"
        v-for="(item, index) in categoryList"
        :key="index"
        @click="openTraceDialog(item)"
      >
        <div class="sn-bs-content-item-left">
          <img
            class="sn-bs-content-item-left__img"
            :src="setImgUrl(item.goodsImgUrl, 50, 50)"
            alt=""
          />
          <div class="sn-bs-content-item-info">
            <p class="sn-bs-content-item-info__p">{{ item.goodsName }}</p>
            <span class="sn-bs-content-item-info__span">
              采收时间：{{ item.pickTime | formatDate("yyyy.MM.dd") }}
            </span>
          </div>
        </div>
        <div class="sn-bs-content-item-right">
          <span
            v-if="
              item.cropSubjectIdentifier === 'agri' ||
              item.cropSubjectIdentifier === 'fishery'
            "
            >{{ item.pickOutput + item.cropCategoryUnit }}</span
          >
          <span v-else>{{ item.pickNum + item.cropCategoryUnit }}</span>
        </div>
      </div>
    </main>
    <empty v-if="!loading && !categoryList.length"></empty>
    <agri-trace-dialog
      v-model="visibility"
      :agri-trace-info="agriTraceInfo"
    ></agri-trace-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { qrCode } from "@/api/request/snkd.produce";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import AgriTraceDialog from "@/views/bs/Farm/components/AgriTraceDialog";
import { setImgUrl } from "@/utils";

export default {
  name: "AgriTrace",
  components: { Empty, AgriTraceDialog },
  data() {
    return {
      loading: false,
      categoryList: [],
      visibility: false,
      agriTraceInfo: {},
    };
  },
  computed: {
    ...mapState(["companyId", "farmId"]),
  },
  mounted() {
    this.initModel();
  },
  methods: {
    setImgUrl,
    async initModel() {
      this.loading = true;
      try {
        const res = await qrCode.listByFarmIdService({
          companyId: this.companyId,
          farmId: this.farmId,
        });
        this.categoryList = res;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async openTraceDialog(info) {
      this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
      this.visibility = true;
      this.agriTraceInfo = info;
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  @include utils-full-box();
  padding-left: 10px;
  box-sizing: border-box;

  @include e(main) {
    @include utils-scrollbar();
    @include utils-full-box();
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @include bs(content-item) {
      margin-top: 10px;
      padding: 10px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: rgba(27, 165, 101, 0.2);
      cursor: pointer;

      @include bs(content-item-left) {
        display: flex;
        align-items: center;

        @include e(img) {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        @include bs(content-item-info) {
          margin-left: 12px;
          @include e(p) {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: bold;
            color: $--color-white;
            line-height: 14px;
          }

          @include e(span) {
            font-size: 14px;
            font-weight: 400;
            color: #9dd1d7;
            line-height: 14px;
          }
        }
      }

      @include bs(content-item-right) {
        text-align: center;
        font-size: 16px;
        color: $--color-primary;
        font-weight: bold;
      }
    }
  }
}
</style>
